module.exports = __webpack_public_path__ + "static/media/4.a39f0e39.jpg";